import type { CustomizationView, GetCustomizationResponse } from '@api-client/products';

export const getCustomizationWithFallback = (
    fallbackValue: CustomizationView,
    customizationResponse: GetCustomizationResponse = {},
): GetCustomizationResponse =>
    !customizationResponse._embedded
        ? { ...customizationResponse, _embedded: { 'customization-view': fallbackValue } }
        : customizationResponse;
